import * as React from "react";
const SuperverseLogo = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 310 310"
    style={{
      enableBackground: "new 0 0 310 310",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n\t.st0{opacity:0.998;fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#71F194;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#71F294;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#477E55;}\n"
      }
    </style>
    <g>
      <path
        className="st0"
        d="M137,0c11.7,0,23.3,0,35,0c71.4,11.9,116.2,52.9,134.5,123c1.5,8.4,2.7,16.8,3.5,25c0,4.3,0,8.7,0,13 c-5.2,61.5-35.2,106.3-90,134.5c-18.9,8.5-38.6,13.3-59,14.5c-4.3,0-8.7,0-13,0C82.1,303.9,35.9,270.6,9.5,210 C5,197.5,1.9,184.8,0,172c0-11.7,0-23.3,0-35C14,59.7,59.7,14,137,0z"
      />
    </g>
    <g>
      <path
        className="st1"
        d="M85,204c-14.3,0-28.7,0-43,0c0-14.3,0-28.7,0-43c4.6-5.1,9.5-10.1,14.5-15c0.3-21.3,0.7-42.7,1-64 C68.7,70.8,79.8,59.7,91,48.5c14.7-0.5,29.3-0.7,44-0.5c0.2,14.3,0,28.7-0.5,43c-5.3,5.3-10.7,10.7-16,16c-0.3,21.3-0.7,42.7-1,64 C106.5,181.9,95.6,192.9,85,204z"
      />
    </g>
    <g>
      <path
        className="st2"
        d="M128,256c-14.3,0-28.7,0-43,0c0-14.3,0-28.7,0-43c12.6-13.1,25.5-26.1,38.5-39c0.3-21.3,0.7-42.7,1-64 c18.8-18.8,37.7-37.7,56.5-56.5c14.7-0.5,29.3-0.7,44-0.5c0.2,14.3,0,28.7-0.5,43c-13,13-26,26-39,39c-0.3,21.3-0.7,42.7-1,64 C165.5,217.9,146.6,236.9,128,256z"
      />
    </g>
    <g>
      <path
        className="st1"
        d="M224,105c14.7,0,29.3,0,44,0c0.2,14.3,0,28.7-0.5,43c-5,5-10,10-15,15c-0.3,21.3-0.7,42.7-1,64 c-11.2,11.2-22.3,22.3-33.5,33.5c-14.3,0.5-28.7,0.7-43,0.5c-0.2-14.7,0-29.3,0.5-44c5-5,10-10,15-15c0.3-21.3,0.7-42.7,1-64 C202.5,127.1,213.4,116.1,224,105z"
      />
    </g>
    <g>
      <path
        className="st3"
        d="M42,161c0,14.3,0,28.7,0,43c14.3,0,28.7,0,43,0c-14.5,1-29.2,1.3-44,1C40.7,190.2,41,175.5,42,161z"
      />
    </g>
    <g>
      <path
        className="st3"
        d="M85,213c0,14.3,0,28.7,0,43c14.3,0,28.7,0,43,0c-14.5,1-29.2,1.3-44,1C83.7,242.2,84,227.5,85,213z"
      />
    </g>
  </svg>
);
export default SuperverseLogo;
